export const STAFF = 'staff';
export const MANAGER = 'manager';
export const COMPANY = 'company';
export const ADMIN = 'admin';
export const SUPERADMIN = 'superadmin';
